const SuperUsercheck = ["SuperUser","Support@amuleasingpl.com"]


const EmailcheckFn = (email , checkArray)=>{
    if(checkArray.includes(email)){
        return true
    }
    return false
}
const EmailNotcheckFn = (email , checkArray)=>{
    if(!checkArray.includes(email)){
        return true
    }
    return false
}


export {
    EmailcheckFn,EmailNotcheckFn,
    SuperUsercheck,
   

}